'use strict'

const crypto = require('libp2p-crypto')
const constants = require('./constants')

exports = module.exports

exports.rnd = (length) => {
  if (!length) {
    length = constants.PING_LENGTH
  }
  return crypto.randomBytes(length)
}



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-ping/src/util.js
// module id = 275
// module chunks = 0